import React from "react";
import { Switch, Route } from 'react-router-dom';
import websiteData from '../data.json';
//import withTracker from '../pages/submit/withTracker';
/* Import Website Pages*/ 
import HomePage from "./home-page";
import AboutPage from "./about-page";
import ServicesPage from "./services-page";
import CareerPage from "./career-page";
import BlogPage from "./blog-page";
import ContactPage from "./contact-page";
import ArticlePage from "./article-page";
import Page404 from "./page-404";
import AdminPage from "./admin";
import PrivacyPolicyPage from "./privacy-policy-page";


const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}

/* Route that shares the same props - used to create the Blog|Article sections */
const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }}/>
  );
}


export default class PageBody extends React.Component {
  render() {
        const pageBody = websiteData.page_body,
              dataBlogEntries = pageBody.blogEntries;    
    return (
        <Switch>
            <Route exact path='/' component={HomePage}/>
            <Route path='/about' component={AboutPage}/>
            <Route path='/services' component={ServicesPage}/>
            <Route path='/career' component={CareerPage}/>
            <PropsRoute path='/blog' component={BlogPage} blogEntries={dataBlogEntries}/>
            <PropsRoute path='/article' component={ArticlePage} blogEntries={dataBlogEntries}/>
            <Route path='/contact' component={ContactPage}/>
            <Route path='/admin' component={AdminPage}/>      
            <Route path='/privacy' component={PrivacyPolicyPage}/>       
            <Route component={Page404}/>
        </Switch>
     );
  }
}


// WEBPACK FOOTER //
// ./src/pages/page_body.js